import entities from "./entities"

const getCep = async (cep: string) => {
  try {
    const cepResult = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
    const cepResultParsed = await cepResult.json()
  
    if (cepResultParsed?.erro) {
      return Promise.reject(cepResultParsed)
    }
  
    const address = entities.Address(cepResultParsed)
  
    return address
  } catch {
    return Promise.resolve(entities.Address({ cep }))
  }
}

export default {
  getCep,
}
